import styles from "./Banner.module.css";

export const CloseIcon = ({ color, onClick }: { color: string; onClick?: () => void }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      className={styles.closeIcon}
      onClick={onClick}
    >
      <path
        d="M0.12947 1.81537L0.103248 1.84159L3.46876 5.2071C4.18143 5.91977 4.18136 7.07584 3.46861 7.78858L0.100342 11.1569L1.36479 12.4213L1.3922 12.4475L4.75809 9.08163C5.47084 8.36889 6.6269 8.36882 7.33957 9.08149L10.7075 12.4494L11.9721 11.1848L11.9971 11.1586L8.63158 7.79306C7.91891 7.08039 7.91897 5.92433 8.63172 5.21158L12 1.84331L10.7355 0.578859L10.7081 0.552636L7.34225 3.91852C6.6295 4.63127 5.47343 4.63134 4.76076 3.91867L1.39287 0.550781L0.128278 1.81537L0.12947 1.81537Z"
        fill={color}
      />
    </svg>
  );
};
